import React, { Fragment, useState, useEffect, useContext } from 'react';
import { Button, FormGroup, Input } from 'reactstrap';
import { formatPrice } from '../../../../../../common/numberFormat';
import { ProjectContext } from '../../../../../../context/Project';
import { APPConstants } from '../../../../../../constants/app';
import { APIConstants } from '../../../../../../constants/api';
import ThumbnailNotAvailable from '../../../../assets/material/thumbnail_not_available.svg';
import CrossCircle from '../../../../assets/cross-circle.svg';

function MaterialList({ materialsByProjectType, spaceChanged, selectedMaterials }) {
    const { getMaterials, setMaterials } = useContext(ProjectContext);
    const [addedMaterials, setAddedMaterials] = useState({});

    useEffect(() => {
        let contextMaterials = getMaterials();

        if (contextMaterials) {
            setAddedMaterials(contextMaterials);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        setMaterials(addedMaterials);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [addedMaterials]);

    useEffect(() => {
        let currentMaterials = getMaterials();
        if (currentMaterials
            && Object.keys(currentMaterials).length === 0
            && Object.keys(addedMaterials).length === 0
            && Object.keys(selectedMaterials).length > 0
        ) {
            setAddedMaterials(selectedMaterials);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedMaterials]);

    useEffect(() => {
        if (spaceChanged) {
            setAddedMaterials({});
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [spaceChanged]);

    const handleMaterialPriceListTypeChange = (materialId, event) => {
        let materialCategoryId = parseInt(event.target.value);
        let material = materialsByProjectType.find((material) => material.key === materialId);
        let priceList = material.materialPriceLists.find((materialPriceList) => {
            return materialPriceList.materialCategory.id === materialCategoryId;
        });

        setAddedMaterials({
            ...addedMaterials,
            [materialId]: {
                ...addedMaterials[materialId],
                price: priceList?.price,
                materialCategoryId: event.target.value
            }
        })
    }

    const handleMaterialQuantityChange = (materialId, event) => {
        setAddedMaterials({
            ...addedMaterials,
            [materialId]: {
                ...addedMaterials[materialId],
                quantity: parseInt(event.target.value)
            }
        })
    }

    const handleMaterialAddClick = (materialId) => {
        let material = materialsByProjectType.find((material) => material.key === materialId);
        let materialPriceListDefault = material.materialPriceLists.find(() => true);
        let materialCategoryDefault = materialPriceListDefault.materialCategory;

        setAddedMaterials({
            ...addedMaterials,
            [materialId]: {
                materialId: material.id,
                materialCategoryId: materialCategoryDefault?.id,
                currency: materialPriceListDefault.currency,
                price: materialPriceListDefault.price,
                name: material.name,
                quantity: 1
            }
        })
    }

    const handleMaterialRemoveClick = (materialId) => {
        const materials = {...addedMaterials};
        delete materials[materialId];
        setAddedMaterials(materials);
    }

    const getFormattedPriceFrom = (materialPriceLists) => {
        let fromPrice = null;

        if (Array.isArray(materialPriceLists)) {
            materialPriceLists.forEach(function(materialPrice) {
                if (materialPrice.price > 0 && fromPrice === null) {
                    fromPrice = materialPrice.price;
                    return;
                }
                if (materialPrice.price < fromPrice) {
                    fromPrice = materialPrice.price;
                }
            })
        }

        return fromPrice && fromPrice > 0 ? formatPrice(fromPrice) : '-';
    }

    var materials = materialsByProjectType.map(
        (material) =>
            <div key={material.key} className={`material m-b-20 ${addedMaterials[material.key] ? 'selected' : ''}`}>
                <div className="cont-img">
                    <Fragment>
                        {
                            addedMaterials[material.key] &&
                            <a
                                className="material-remove"
                                onClick={ e => handleMaterialRemoveClick(material.key, e)}
                            >
                                <img alt="" src={CrossCircle}/>
                            </a>
                        }
                    </Fragment>
                    <img
                        className='material-thumbnail'
                        src={`/${APIConstants.URLS.MATERIAL.BASE}/${material.id}/thumbnail`}
                        alt={material.name}
                        onError={(e) => {e.target.src = ThumbnailNotAvailable}}
                    />
                </div>
                <div className="cont-text">
                    <a href="#">
                        <h3>{material.name}</h3>
                    </a>
                    {
                        material?.description &&
                        <span className="description">{material.description}</span>
                    }
                    <span className="from">From {getFormattedPriceFrom(material.materialPriceLists)}</span>
                    {
                        !addedMaterials[material.key] &&
                        <Button className="additem"
                            onClick={e => handleMaterialAddClick(material.key)}
                        >
                            Add item
                        </Button>
                    }
                    {
                        addedMaterials[material.key] &&
                        <>
                            <div className="selects">
                                <FormGroup>
                                    <Input name="quantity" type="select"
                                        value={addedMaterials[material.key]?.quantity}
                                        onChange={e => handleMaterialQuantityChange(material.key, e)}>
                                        {
                                            [
                                                ...Array((addedMaterials[material.key]?.quantity + APPConstants.MATERIAL_MAX_QUANTITY)
                                                    || APPConstants.MATERIAL_MAX_QUANTITY).keys()
                                            ]
                                                .map(
                                                    (i) =>
                                                        <option
                                                            key={i + 1}
                                                            value={i + 1}
                                                        >
                                                            {i + 1}
                                                        </option>
                                                )
                                        }
                                    </Input>
                                </FormGroup>
                                <FormGroup>
                                    <Input name="quality" type="select"
                                        onChange={e => handleMaterialPriceListTypeChange(material.key, e)}
                                        value={addedMaterials[material.key]?.materialCategoryId}
                                    >
                                        {
                                            material.materialPriceLists.map(
                                                (priceList) =>
                                                    <option
                                                        key={priceList.materialCategory.id}
                                                        value={priceList.materialCategory.id}
                                                    >
                                                        {priceList.materialCategory.description}
                                                    </option>
                                            )
                                        }
                                    </Input>
                                </FormGroup>
                            </div>
                            {
                                material.measurementUnit &&
                                <div className='material-measurement-unit ms-1'>
                                    <small>{material.measurementUnit.shortDescription}</small>
                                </div>
                            }
                        </>
                    }
                </div>
            </div>
    );

    return (
        <Fragment>
            {materials}
        </Fragment>
    );
}

export default MaterialList;